import * as types from './types';

export const fetchApplicationSummaryById = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_FETCH_APPLICATION_SUMMARY_BY_ID,
    applicationId
});

export const setApplicationSummary = (applicationSummary) => ({
    type: types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY,
    applicationSummary
})

export const setApplicationSummaryLoading  = (isApplicationSummaryLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY_LOADING,
    isApplicationSummaryLoading
});

export const resetCandidateApplicationState  = () => ({
    type: types.CANDIDATE_APPLICATION_RESET_CANDIDATE_APPLICATION_STATE
});

export const setApplicationSummaryRequestFailedCode = (applicationSummaryRequestFailedCode) => ({
    type: types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY_REQUEST_FAILED_CODE,
    applicationSummaryRequestFailedCode
});

export const getCandidateApplicationCoverLetter = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_GET_COVER_LETTER,
    applicationId
});

export const setCandidateApplicationCoverLetter = (candidateApplicationCoverLetter) => ({
    type: types.CANDIDATE_APPLICATION_SET_COVER_LETTER,
    candidateApplicationCoverLetter
});

export const setCandidateApplicationCoverLetterLoading = (isLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_SET_COVER_LETTER_LOADING,
    isLoading
});

export const resetCandidateApplicationCoverLetter = () => ({
    type: types.CANDIDATE_APPLICATION_RESET_COVER_LETTER
});

export const getCandidateApplicationSupplementaryQuestions = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_GET_SUPPLEMENTARY_QUESTIONS,
    applicationId
});

export const setCandidateApplicationSupplementaryQuestions = (candidateApplicationSupplementaryQuestions) => ({
    type: types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS,
    candidateApplicationSupplementaryQuestions
});

export const setCandidateApplicationSupplementaryQuestionsLoading = (isLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_LOADING,
    isLoading
});

export const resetCandidateApplicationSupplementaryQuestions = () => ({
    type: types.CANDIDATE_APPLICATION_RESET_SUPPLEMENTARY_QUESTIONS
});

export const withdrawCandidateApplication = (applicationId, reasonId) => ({
  type: types.CANDIDATE_APPLICATION_WITHDRAW,
  applicationId,
  reasonId
});

export const setCandidateApplicationWithdrawing = (isLoading) => ({
  type: types.CANDIDATE_APPLICATION_SET_WITHDRAWING,
  isLoading
});

export const reSubmitCandidateApplication = (applicationId, reasonId) => ({
  type: types.CANDIDATE_APPLICATION_RESUBMIT,
  applicationId
});

export const setCandidateApplicationReSubmitting = (isLoading) => ({
  type: types.CANDIDATE_APPLICATION_SET_RESUBMITTING,
  isLoading
});

export const submitCandidateApplication = (applicationId, reasonId) => ({
  type: types.CANDIDATE_APPLICATION_SUBMIT,
  applicationId
});

export const setCandidateApplicationPrintVersionIsLoading = (printVersionIsLoading) => ({
  type: types.CANDIDATE_APPLICATION_SET_PRINT_VERSION_IS_LOADING,
  printVersionIsLoading
});

export const printCandidateApplication = (applicationId) => ({
  type: types.CANDIDATE_APPLICATION_PRINT_CANDIDATE_APPLICATION,
  applicationId
});



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-application/index.js